var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filter-input-value" }, [
    _vm.showSelectValueOrFieldTpl
      ? _c(
          "div",
          { staticClass: "setup-input" },
          [
            _c(
              "el-select",
              {
                staticClass: "left-input w-[120px]",
                attrs: {
                  disabled:
                    (_vm.isShareFilter && _vm.isFromRoma) ||
                    _vm.globalFieldsMapItem.isQueryField ||
                    _vm.$attrs.disabled,
                  size: "mini",
                },
                on: { change: _vm.inputTypeChange },
                model: {
                  value: _vm.inputType,
                  callback: function ($$v) {
                    _vm.inputType = $$v
                  },
                  expression: "inputType",
                },
              },
              _vm._l(_vm.optionsValueView, function (item) {
                return _c("el-option", {
                  attrs: { label: item.label, value: item.value },
                })
              }),
              1
            ),
            _vm._v(" "),
            _vm.inputType === "field"
              ? _c(
                  "div",
                  [
                    !_vm.isFieldsGroup
                      ? _c(
                          "el-select",
                          {
                            staticClass: "right-input",
                            attrs: {
                              filterable: "",
                              placeholder: "请选择字段",
                              size: "mini",
                              disabled: _vm.$attrs.disabled,
                            },
                            on: { change: _vm.rightTableChange },
                            model: {
                              value: _vm.filterItem.rightFilterField,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.filterItem,
                                  "rightFilterField",
                                  $$v
                                )
                              },
                              expression: "filterItem.rightFilterField",
                            },
                          },
                          _vm._l(_vm.fieldListView, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.field },
                            })
                          }),
                          1
                        )
                      : _c("el-cascader", {
                          ref:
                            "filterItem" +
                            _vm.$attrs.groupIndex +
                            _vm.$attrs.filterItemIndex,
                          class: [
                            "filterItem" +
                              _vm.$attrs.groupIndex +
                              _vm.$attrs.filterItemIndex,
                            "w210",
                            { ml6: !_vm.codeList.length },
                            { "err-select": _vm.judgeDelete() },
                          ],
                          attrs: {
                            props: Object.assign(
                              {},
                              { emitPath: false },
                              _vm.$attrs.customProps,
                              _vm.localProps
                            ),
                            size: "mini",
                            options: !!_vm.codeList.length
                              ? _vm.codeList
                              : _vm.fieldListView,
                            "show-all-levels": false,
                            "before-filter": _vm.chooseFirstOption,
                            "filter-method": _vm.filterNode,
                            filterable: "",
                            clearable: "",
                            separator: _vm.separatorSymbol,
                            disabled: _vm.$attrs.disabled,
                          },
                          on: {
                            change: function (val) {
                              return _vm.rightTableChange(
                                val,
                                "filterItem" +
                                  _vm.$attrs.groupIndex +
                                  _vm.$attrs.filterItemIndex
                              )
                            },
                            "visible-change": function ($event) {
                              return _vm.changeFieldVisible($event)
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var node = ref.node
                                  var data = ref.data
                                  return [
                                    _c(
                                      "span",
                                      { attrs: { title: data.label } },
                                      [_vm._v(_vm._s(data.label))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3510428858
                          ),
                          model: {
                            value: _vm.filterItem.rightFilterField,
                            callback: function ($$v) {
                              _vm.$set(_vm.filterItem, "rightFilterField", $$v)
                            },
                            expression: "filterItem.rightFilterField",
                          },
                        }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.inputType === "attribute"
              ? _c(
                  "el-select",
                  {
                    ref: "selectField",
                    staticClass: "right-input",
                    class: { "err-select": _vm.judgeRightDelete() },
                    attrs: {
                      placeholder: "请选择属性",
                      size: "mini",
                      "value-key": "fieldWid",
                      disabled: _vm.$attrs.disabled,
                    },
                    on: { change: _vm.rightListChange },
                    model: {
                      value: _vm.filterItem.rightFilterField,
                      callback: function ($$v) {
                        _vm.$set(_vm.filterItem, "rightFilterField", $$v)
                      },
                      expression: "filterItem.rightFilterField",
                    },
                  },
                  _vm._l(_vm.attributeList, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isCodeField && _vm.inputType === "code"
              ? _c("el-cascader", {
                  ref:
                    "filterItem" +
                    _vm.$attrs.groupIndex +
                    _vm.$attrs.filterItemIndex,
                  class: [
                    "filterItem" +
                      _vm.$attrs.groupIndex +
                      _vm.$attrs.filterItemIndex,
                    "w210",
                    { ml6: !_vm.codeList.length },
                    { "err-select": _vm.judgeDelete() },
                  ],
                  attrs: {
                    props: Object.assign(
                      {},
                      { emitPath: false },
                      _vm.localProps
                    ),
                    size: "mini",
                    options: !!_vm.codeList.length
                      ? _vm.codeList
                      : _vm.fieldListView,
                    "show-all-levels": false,
                    "before-filter": _vm.chooseFirstOption,
                    filterable: "",
                    clearable: "",
                    separator: _vm.separatorSymbol,
                    disabled: _vm.$attrs.disabled,
                  },
                  on: {
                    change: _vm.rightTableChange,
                    "visible-change": function ($event) {
                      return _vm.changeFieldVisible($event)
                    },
                  },
                  model: {
                    value: _vm.filterItem.rightFilterField,
                    callback: function ($$v) {
                      _vm.$set(_vm.filterItem, "rightFilterField", $$v)
                    },
                    expression: "filterItem.rightFilterField",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inputType === "value" &&
            !_vm.isDate &&
            _vm.globalFieldsMapItem.isQueryField
              ? _c("el-autocomplete", {
                  attrs: {
                    size: "mini",
                    "fetch-suggestions": _vm.querySearch,
                    placeholder: "请输入内容",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "query-item-text",
                                staticStyle: {
                                  overflow: "hidden",
                                  "text-overflow": "ellipsis",
                                  "white-space": "nowrap",
                                },
                                attrs: { title: item.value },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(item.value) +
                                    "\n        "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2195383735
                  ),
                  model: {
                    value: _vm.filterItem.rightFilterValue.filterValue,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.filterItem.rightFilterValue,
                        "filterValue",
                        $$v
                      )
                    },
                    expression: "filterItem.rightFilterValue.filterValue",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            (_vm.inputType === "value" &&
              !_vm.isDate &&
              !_vm.globalFieldsMapItem.isQueryField) ||
            _vm.inputType === "expression"
              ? _c("el-input", {
                  staticClass: "right-input",
                  attrs: {
                    size: "mini",
                    placeholder:
                      _vm.inputType === "expression"
                        ? "请输入表达式"
                        : "请输入值",
                    disabled: _vm.$attrs.disabled,
                  },
                  model: {
                    value: _vm.filterItem.rightFilterValue.filterValue,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.filterItem.rightFilterValue,
                        "filterValue",
                        $$v
                      )
                    },
                    expression: "filterItem.rightFilterValue.filterValue",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inputType === "value" && _vm.isDate && !_vm.isTime
              ? _c("el-date-picker", {
                  staticClass: "right-input",
                  attrs: {
                    "prefix-icon": "el-icon-date",
                    size: "mini",
                    type: _vm.isDateTimeCategory
                      ? "datetime"
                      : _vm.isYm
                      ? "month"
                      : "date",
                    placeholder: "请选择日期",
                    "value-format": _vm.isDateTimeCategory
                      ? "yyyy-MM-dd HH:mm:ss"
                      : "yyyy-MM-dd",
                    disabled: _vm.$attrs.disabled,
                  },
                  on: { change: _vm.changeInput },
                  model: {
                    value: _vm.filterItem.rightFilterValue.filterValue,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.filterItem.rightFilterValue,
                        "filterValue",
                        $$v
                      )
                    },
                    expression: "filterItem.rightFilterValue.filterValue",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inputType === "value" && _vm.isDate && _vm.isTime
              ? _c("el-time-picker", {
                  staticClass: "right-input",
                  attrs: {
                    "prefix-icon": "el-icon-date",
                    size: "mini",
                    placeholder: "请选择时间",
                    "value-format": "HH:mm:ss",
                    disabled: _vm.$attrs.disabled,
                  },
                  on: { change: _vm.changeInput },
                  model: {
                    value: _vm.filterItem.rightFilterValue.filterValue,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.filterItem.rightFilterValue,
                        "filterValue",
                        $$v
                      )
                    },
                    expression: "filterItem.rightFilterValue.filterValue",
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm.showSingleInputTpl
      ? _c(
          "div",
          { staticClass: "setup-input" },
          [
            _c("el-input", {
              staticClass: "left-input val-input",
              attrs: {
                value: "值",
                readonly: "",
                size: "mini",
                disabled: _vm.$attrs.disabled,
              },
            }),
            _vm._v(" "),
            _c("el-input", {
              staticClass: "right-input",
              attrs: {
                size: "mini",
                placeholder: "请输入值",
                disabled: _vm.$attrs.disabled,
              },
              on: { change: _vm.singleInputChange },
              model: {
                value: _vm.filterItem.showRightField,
                callback: function ($$v) {
                  _vm.$set(_vm.filterItem, "showRightField", $$v)
                },
                expression: "filterItem.showRightField",
              },
            }),
          ],
          1
        )
      : _vm.showDuplicateTpl
      ? _c(
          "div",
          { staticClass: "setup-input" },
          [
            _c("el-input", {
              staticClass: "left-input val-input",
              attrs: {
                value: "值",
                readonly: "",
                size: "mini",
                disabled: _vm.$attrs.disabled,
              },
            }),
            _vm._v(" "),
            _c(
              "el-popover",
              {
                staticClass: "right-input",
                staticStyle: { "margin-top": "-1px" },
                attrs: { placement: "bottom", width: "210", trigger: "manual" },
                model: {
                  value: _vm.popoverControl,
                  callback: function ($$v) {
                    _vm.popoverControl = $$v
                  },
                  expression: "popoverControl",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "p-[2px]", staticStyle: { padding: "2px" } },
                  [
                    _c("el-input", {
                      staticClass: "textarea-disabled-resize",
                      attrs: {
                        size: "mini",
                        type: "textarea",
                        placeholder: "每行一个值，换行分隔",
                        rows: 3,
                        disabled: _vm.$attrs.disabled,
                      },
                      model: {
                        value: _vm.filterVal,
                        callback: function ($$v) {
                          _vm.filterVal = $$v
                        },
                        expression: "filterVal",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-right pr-[2px] mt-[4px]",
                        staticStyle: { "margin-top": "4px" },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: { click: _vm.popoverChange },
                          },
                          [_vm._v("取 消")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: { click: _vm.setFilterVal },
                          },
                          [_vm._v("确 定")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-input", {
                  ref: "slotInput",
                  attrs: {
                    slot: "reference",
                    size: "mini",
                    placeholder: "请输入值",
                    disabled: _vm.$attrs.disabled,
                  },
                  on: { focus: _vm.slotInputFocus },
                  slot: "reference",
                  model: {
                    value: _vm.rightFilterFieldView,
                    callback: function ($$v) {
                      _vm.rightFilterFieldView = $$v
                    },
                    expression: "rightFilterFieldView",
                  },
                }),
              ],
              1
            ),
          ],
          1
        )
      : _vm.isBetweenCategory
      ? _c(
          "div",
          { staticClass: "setup-input" },
          [
            _vm.isNumber || _vm.isFromRoma
              ? _c("el-input", {
                  staticClass: "left-input between-input",
                  attrs: {
                    type: _vm.isFromRoma ? "text" : "number",
                    size: "mini",
                    placeholder: _vm.isFromRoma ? "请输入" : "请输入值",
                    disabled: _vm.$attrs.disabled,
                  },
                  model: {
                    value: _vm.filterItem.between[0],
                    callback: function ($$v) {
                      _vm.$set(_vm.filterItem.between, 0, $$v)
                    },
                    expression: "filterItem.between[0]",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isDate && !_vm.isTime
              ? _c("el-date-picker", {
                  staticClass: "left-input between-input",
                  attrs: {
                    "prefix-icon": "el-icon-date",
                    size: "mini",
                    type: _vm.isDateTimeCategory
                      ? "datetime"
                      : _vm.isYm
                      ? "month"
                      : "date",
                    placeholder: "不限",
                    "value-format": _vm.isDateTimeCategory
                      ? "yyyy-MM-dd HH:mm:ss"
                      : "yyyy-MM-dd",
                    disabled: _vm.$attrs.disabled,
                  },
                  on: { change: _vm.changeInput },
                  model: {
                    value: _vm.filterItem.between[0],
                    callback: function ($$v) {
                      _vm.$set(_vm.filterItem.between, 0, $$v)
                    },
                    expression: "filterItem.between[0]",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inputType === "value" && _vm.isDate && _vm.isTime
              ? _c("el-time-picker", {
                  staticClass: "right-input between-input",
                  attrs: {
                    "prefix-icon": "el-icon-date",
                    size: "mini",
                    placeholder: "请选择时间",
                    "value-format": "HH:mm:ss",
                    disabled: _vm.$attrs.disabled,
                  },
                  on: { change: _vm.changeInput },
                  model: {
                    value: _vm.filterItem.between[0],
                    callback: function ($$v) {
                      _vm.$set(_vm.filterItem.between, 0, $$v)
                    },
                    expression: "filterItem.between[0]",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "mx-[6px]" }, [_vm._v("和")]),
            _vm._v(" "),
            _vm.isNumber || _vm.isFromRoma
              ? _c("el-input", {
                  staticClass: "right-input between-input",
                  attrs: {
                    type: _vm.isFromRoma ? "text" : "number",
                    size: "mini",
                    placeholder: _vm.isFromRoma ? "请输入" : "请输入值",
                    disabled: _vm.$attrs.disabled,
                  },
                  model: {
                    value: _vm.filterItem.between[1],
                    callback: function ($$v) {
                      _vm.$set(_vm.filterItem.between, 1, $$v)
                    },
                    expression: "filterItem.between[1]",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isDate && !_vm.isTime
              ? _c("el-date-picker", {
                  staticClass: "right-input between-input",
                  attrs: {
                    "prefix-icon": "el-icon-date",
                    size: "mini",
                    type: _vm.isDateTimeCategory
                      ? "datetime"
                      : _vm.isYm
                      ? "month"
                      : "date",
                    placeholder: "不限",
                    "value-format": _vm.isDateTimeCategory
                      ? "yyyy-MM-dd HH:mm:ss"
                      : "yyyy-MM-dd",
                    disabled: _vm.$attrs.disabled,
                  },
                  on: { change: _vm.changeInput },
                  model: {
                    value: _vm.filterItem.between[1],
                    callback: function ($$v) {
                      _vm.$set(_vm.filterItem.between, 1, $$v)
                    },
                    expression: "filterItem.between[1]",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.inputType === "value" && _vm.isDate && _vm.isTime
              ? _c("el-time-picker", {
                  staticClass: "right-input between-input",
                  attrs: {
                    "prefix-icon": "el-icon-date",
                    size: "mini",
                    placeholder: "请选择时间",
                    "value-format": "HH:mm:ss",
                    disabled: _vm.$attrs.disabled,
                  },
                  on: { change: _vm.changeInput },
                  model: {
                    value: _vm.filterItem.between[1],
                    callback: function ($$v) {
                      _vm.$set(_vm.filterItem.between, 1, $$v)
                    },
                    expression: "filterItem.between[1]",
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }